import { Container } from '@/components/ui/template/Container'

export function TopSection() {
	return (
		<Container>
			<Container.BackgroundImage
				src="/images/pepper-inc-bg/600.webp"
				srcSet="/images/pepper-inc-bg/600.webp 600w,
					/images/pepper-inc-bg/1280.webp 1280w,
					/images/pepper-inc-bg/1804.webp 1804w,
					/images/pepper-inc-bg/2412.webp 2412w"
				sizes="100vw"
				alt="Pepper Inc. BG"
			/>
			<Container.Content className="flex flex-col justify-center items-center relative text-center px-6 pt-[140px] md:pt-[140px] pb-12 lg:pt-36 lg:pb-20 lg:px-0 gap-3 lg:gap-0 text-neutral md:min-h-[200px] lg:min-h-[300px] leading-none uppercase">
				<h2 className="text-[3.5rem] md:text-[3.75rem] lg:text-[6rem] leading-none">PEPPER INC.</h2>
				<h4 className="leading-none text-[1.75rem]">(NOT ACTUALLY AN INC. LOL)</h4>
			</Container.Content>
		</Container>
	)
}
